import eventBus from '@/helpers/eventBus'
import { nextTick } from 'vue'
export default {
  methods: {
    goToPage: (pageName, self) => {
      nextTick(() => {
        eventBus.emit('goToPage-event', pageName);

        // change url when moving to another page
        // Add country code to url when changing page
        history.replaceState({}, null, '/' + localStorage.getItem('lang') + '/' + pageName)
      })
    },
    sendProductPhotos: (params, buttonComponent) => {
      let fieldId = params;
      // console.log("1. will SEND products:::", fieldId, buttonComponent)

      buttonComponent.loading = true;
      buttonComponent.$eventHub.on('done-event-trigger',
        (parent) => buttonComponent.doneTrigger(buttonComponent, parent));

      buttonComponent.$eventHub.emit('sendProductPhotos-event', fieldId);
    },
    sendForm: (params, buttonComponent) => {
      if (params.indexOf(',') > -1) {
        params = params.split(',')
      }
      let formId = params;
      let neuStarTrigger = false
      if (self._.isArray(params)) {
        formId = params[0]
        neuStarTrigger = params.filter(param => param === 'neuStarTrigger')
        // console.log("1. will SEND FORM:::", formId, 'neuStarTrigger', neuStarTrigger.length > 0)
      }
      const triggers = {
        neuStarTrigger: neuStarTrigger.length > 0
      }
      // console.log("1. will SEND FORM:::", formId, "NO TRIGGER")
      buttonComponent.loading = true;
      buttonComponent.$eventHub.on('done-event-trigger',
        (parent) => buttonComponent.doneTrigger(buttonComponent, parent));
      // console.log("2. will SEND FORM:::", formId, buttonComponent)

      buttonComponent.$eventHub.emit('getFormData-event', formId, triggers);
    },
    sendProducts: (formId, buttonComponent) => {
      // console.log("SEND PRODUCTS:::", formId)
      buttonComponent.loading = true;
      buttonComponent.$eventHub.on('done-event-trigger',
        (parent) => buttonComponent.doneTrigger(buttonComponent, parent));
      buttonComponent.$eventHub.emit('sendProducts-event', formId);
    },
    sendSurvey: (component, buttonComponent) => {
      // console.log("1. will SEND SMS:::", formId, "NO TRIGGER")
      buttonComponent.loading = true;
      buttonComponent.$eventHub.on('done-event-trigger',
        (parent) => buttonComponent.doneTrigger(buttonComponent, parent));
      buttonComponent.$eventHub.emit('getSurveyData-event');
    },
    printForm: (formId, buttonComponent) => {
      // console.log("SEND PRODUCTS:::", formId)
      buttonComponent.loading = true;
      buttonComponent.$eventHub.on('done-event-trigger',
        (parent) => buttonComponent.doneTrigger(buttonComponent, parent));
      buttonComponent.$eventHub.emit('printForm-event', formId);
    },
    getCustomerToken: (params, self) => {
      // console.log("getCustomerToken", self)
      self.$store.dispatch('retrieveUserToken')
    },
    doneTrigger: (component, eventResult) => {
      component.$eventHub.off('done-event-trigger');
      component.loading = false
      if (!eventResult.status && eventResult.message) {
        component.showModal(eventResult.message)
      }

    },
    sendReceipt: (component, buttonComponent) => {
      buttonComponent.loading = true;
      buttonComponent.$eventHub.emit('sendReceipt-event')
    },
    isMobileOrTablet ( currentScreenSize ) {
      return currentScreenSize < 992 ? true : false
    },
    showModalSuccess (message) {
      this.showModal(message, 'success')
    },
  }
}
